"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openUrl = exports.openInNewWindow = exports.appHardwareBackEventListener = exports.postMessageToNativeApp = exports.isWebviewEnv = exports.isIOSApp = exports.isAndroidApp = exports.APP_CALLBACK_ACTION = void 0;

var _window$webkit, _window$webkit$messag, _window$webkit$messag2;

var APP_CALLBACK_ACTION = {
  LOGOUT: "Logout",
  HARDWARE_BACK_PRESSED: "BackPressed",
  EXTERNAL_URL: "ExternalURL",
  PRIORITY_SETTLEMENTS_ACTIVATION_COMPLETED: "PrioritySettlementsActivationCompleted",
  PRINT: "Print"
};
exports.APP_CALLBACK_ACTION = APP_CALLBACK_ACTION;
var isAndroidApp = typeof PayUonboarding != "undefined";
exports.isAndroidApp = isAndroidApp;
var isIOSApp = typeof ((_window$webkit = window.webkit) === null || _window$webkit === void 0 ? void 0 : (_window$webkit$messag = _window$webkit.messageHandlers) === null || _window$webkit$messag === void 0 ? void 0 : (_window$webkit$messag2 = _window$webkit$messag.payuOnboardingCallback) === null || _window$webkit$messag2 === void 0 ? void 0 : _window$webkit$messag2.postMessage) == "function";
exports.isIOSApp = isIOSApp;
var isWebviewEnv = isAndroidApp || isIOSApp;
exports.isWebviewEnv = isWebviewEnv;

var postMessageToNativeApp = function postMessageToNativeApp(payload) {
  try {
    if (isAndroidApp) {
      PayUonboarding.callback(JSON.stringify(payload));
      console.log("Posting back to Android App: \n", payload);
    } else if (isIOSApp) {
      window.webkit.messageHandlers.payuOnboardingCallback.postMessage(payload);
      console.log("Posting back to iOS App: \n", payload);
    }
  } catch (err) {
    console.log("Error in posting message to Native App: \n", err);
  }
};

exports.postMessageToNativeApp = postMessageToNativeApp;

var appHardwareBackEventListener = function appHardwareBackEventListener() {
  try {
    document.addEventListener("backbutton", function () {
      return postMessageToNativeApp({
        action: APP_CALLBACK_ACTION.HARDWARE_BACK_PRESSED
      });
    }, false);
  } catch (err) {
    console.log("Error in appHardwareBackEventListener: ", err);
  }
};

exports.appHardwareBackEventListener = appHardwareBackEventListener;

var openInNewWindow = function openInNewWindow(url) {
  var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    isExternal: true
  };

  if (isWebviewEnv) {
    postMessageToNativeApp({
      action: APP_CALLBACK_ACTION.EXTERNAL_URL,
      data: {
        url: url,
        meta: meta
      }
    });
  } else {
    window.open(url, "_blank");
  }
};

exports.openInNewWindow = openInNewWindow;

var openUrl = function openUrl(_ref) {
  var url = _ref.url,
      _ref$newTab = _ref.newTab,
      newTab = _ref$newTab === void 0 ? true : _ref$newTab,
      _ref$meta = _ref.meta,
      meta = _ref$meta === void 0 ? {} : _ref$meta;

  if (isWebviewEnv) {
    postMessageToNativeApp({
      action: APP_CALLBACK_ACTION.EXTERNAL_URL,
      data: {
        url: url,
        meta: meta
      }
    });
  } else {
    window.open(url, newTab ? "_blank" : "_self");
  }
};

exports.openUrl = openUrl;